
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[...param]",
      function () {
        return require("private-next-pages/posts/[...param].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/[...param]"])
      });
    }
  